var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"min-height":_vm.minHeight,"type":_vm.type,"outlined":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-icon',{staticClass:"mr-5",attrs:{"color":_vm.type}},[_vm._v(_vm._s(_vm.iconName))])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }